import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import LeadModal from '../components/LeadModal';
import { Button } from '../components/ui/button';
import {
  Shield, Users, Building, Zap, Check, ArrowRight,
  Wifi, Network, Smartphone, Nfc, QrCode, Hash,
  ScanFace, PhoneCall, Monitor, LayoutDashboard, Sparkles, TrendingUp
} from 'lucide-react';

const PRODUCT_IMAGES = {
  martell: 'https://customer-assets-jai6qajn.emergentagent.net/job_f1019635-30a4-4e30-8928-d76b984f3d3c/artifacts/65dujxm4_ChatGPT%20Image%2010%20sept%202026%2C%2010_45_30%20a.m..png',
  proA2: 'https://customer-assets-jai6qajn.emergentagent.net/job_f1019635-30a4-4e30-8928-d76b984f3d3c/artifacts/liijbh8h_ChatGPT%20Image%2010%20sept%202026%2C%2010_45_38%20a.m..png',
  smo10p: 'https://customer-assets-jai6qajn.emergentagent.net/job_f1019635-30a4-4e30-8928-d76b984f3d3c/artifacts/6wte5iu7_smo.png',
  plus: 'https://customer-assets-jai6qajn.emergentagent.net/job_f1019635-30a4-4e30-8928-d76b984f3d3c/artifacts/dcti03w8_ChatGPT%20Image%2010%20sept%202026%2C%2010_55_53%20a.m..png',
  pro: 'https://customer-assets-jai6qajn.emergentagent.net/job_f1019635-30a4-4e30-8928-d76b984f3d3c/artifacts/n3m3vobm_ChatGPT%20Image%2010%20sept%202026%2C%2010_56_31%20a.m..png',
  infographic: 'https://customer-assets-jai6qajn.emergentagent.net/job_f1019635-30a4-4e30-8928-d76b984f3d3c/artifacts/dyiwq55r_ChatGPT%20Image%2010%20sept%202026%2C%2011_17_39%20a.m..png',
  brandingVideo: 'https://customer-assets-jai6qajn.emergentagent.net/job_f1019635-30a4-4e30-8928-d76b984f3d3c/artifacts/c1zzdyuy_hf_20261005_004022_3ca89818-42bc-44f4-8252-37963c969c80.mp4'
};

const FEATURE_ICONS = {
  Ethernet: Network,
  'Ethernet / WiFi': Wifi,
  WiFi: Wifi,
  'RFID / NFC': Nfc,
  QR: QrCode,
  PIN: Hash,
  'APP Móvil': Smartphone,
  'Digital Signage': Monitor,
  'Reconocimiento facial': ScanFace,
  'Citofonía directo al usuario': PhoneCall
};

const products = [
  {
    id: 'martell',
    name: 'SKO - Martell',
    tagline: 'Acceso versátil y confiable',
    image: PRODUCT_IMAGES.martell,
    accent: 'blue',
    features: ['Ethernet', 'RFID / NFC', 'QR', 'PIN', 'APP Móvil'],
    uses: ['Cowork', 'Inmobiliarias', 'Conserjerías', 'Edificios'],
    scenario: 'Espacios que conectan',
    scenarioLabel: 'COWORK'
  },
  {
    id: 'proA2',
    name: 'SKO - Pro A2',
    tagline: 'Control profesional e integrado',
    image: PRODUCT_IMAGES.proA2,
    accent: 'emerald',
    features: ['Ethernet / WiFi', 'RFID / NFC', 'APP Móvil'],
    uses: ['Inmobiliarias', 'Edificios', 'Conserjerías', 'Accesos perimetrales'],
    scenario: 'Seguridad que da valor',
    scenarioLabel: 'INMOBILIARIAS'
  },
  {
    id: 'smo10p',
    name: 'SMO - 10P',
    tagline: 'Pantalla de salas y recepción',
    image: PRODUCT_IMAGES.smo10p,
    accent: 'orange',
    features: ['WiFi', 'QR', 'PIN', 'APP Móvil', 'Digital Signage'],
    uses: ['Salas de reunión', 'Recepción', 'Cowork', 'Información y comunicaciones'],
    scenario: 'Experiencias más productivas',
    scenarioLabel: 'SALAS DE REUNIÓN'
  },
  {
    id: 'plus',
    name: 'SKO - Plus',
    tagline: 'Seguridad biométrica avanzada',
    image: PRODUCT_IMAGES.plus,
    accent: 'purple',
    features: ['Ethernet / WiFi', 'RFID / NFC', 'QR', 'PIN', 'APP Móvil', 'Reconocimiento facial'],
    uses: ['Edificios', 'Inmobiliarias', 'Conserjerías', 'Cowork', 'Áreas de alta seguridad'],
    scenario: 'Acceso seguro y moderno',
    scenarioLabel: 'EDIFICIOS'
  },
  {
    id: 'pro',
    name: 'SKO - Pro',
    tagline: 'Control total con citofonía',
    image: PRODUCT_IMAGES.pro,
    accent: 'slate',
    features: [
      'Ethernet / WiFi', 'RFID / NFC', 'QR', 'PIN', 'APP Móvil',
      'Reconocimiento facial', 'Citofonía directo al usuario'
    ],
    uses: ['Edificios', 'Condominios', 'Inmobiliarias', 'Conserjerías', 'Accesos principales'],
    scenario: 'Comunicación sin límites',
    scenarioLabel: 'CONSERJERÍAS'
  }
];

const accentClasses = {
  blue:    { bg: 'bg-blue-500/10',    text: 'text-blue-400',    border: 'border-blue-500/30',    chip: 'bg-blue-500/15 text-blue-300' },
  emerald: { bg: 'bg-emerald-500/10', text: 'text-emerald-400', border: 'border-emerald-500/30', chip: 'bg-emerald-500/15 text-emerald-300' },
  orange:  { bg: 'bg-orange-500/10',  text: 'text-orange-400',  border: 'border-orange-500/30',  chip: 'bg-orange-500/15 text-orange-300' },
  purple:  { bg: 'bg-purple-500/10',  text: 'text-purple-400',  border: 'border-purple-500/30',  chip: 'bg-purple-500/15 text-purple-300' },
  slate:   { bg: 'bg-slate-500/10',   text: 'text-slate-300',   border: 'border-slate-500/30',   chip: 'bg-slate-500/15 text-slate-300' }
};

const pillars = [
  { icon: Shield, title: 'Más seguridad', desc: 'Cifrado end-to-end y gestión de permisos granular.' },
  { icon: Sparkles, title: 'Mejores experiencias', desc: 'Entrada sin fricción con QR, NFC, facial o PIN.' },
  { icon: LayoutDashboard, title: 'Gestión centralizada', desc: 'Un panel único en la nube para toda tu operación.' },
  { icon: TrendingUp, title: 'Listo para crecer', desc: 'Escala de un edificio a toda tu red sin reinstalar.' }
];

export default function SkoPage() {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const skoLineSchema = {
    '@context': 'https://schema.org',
    '@type': 'ProductGroup',
    name: 'Cloudbase Access - Línea SKO',
    description:
      'Línea de controladoras inteligentes Cloudbase Access para control de acceso en coworks, edificios, inmobiliarias, conserjerías y espacios compartidos.',
    brand: { '@type': 'Brand', name: 'Cloudbase Access' },
    productGroupID: 'cloudbase-access-sko',
    hasVariant: products.map((p) => ({
      '@type': 'Product',
      name: p.name,
      description: p.tagline,
      image: p.image,
      brand: { '@type': 'Brand', name: 'Cloudbase Access' },
      category: 'Access Control Hardware',
      additionalProperty: p.features.map((f) => ({
        '@type': 'PropertyValue',
        name: 'Feature',
        value: f
      })),
      audience: {
        '@type': 'BusinessAudience',
        audienceType: p.uses.join(', ')
      },
      offers: {
        '@type': 'Offer',
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
        url: 'https://cloudbase.cl/sko'
      }
    }))
  };

  return (
    <>
      <SEOHead
        title="Cloudbase Access - Controladoras SKO | Control de Acceso Inteligente"
        description="Línea Cloudbase Access: controladoras SKO Martell, Pro A2, SMO 10P, Plus y Pro. Control de acceso inteligente para coworks, edificios, inmobiliarias, conserjerías y condominios en Latinoamérica."
        keywords="controladoras SKO, control de acceso Chile, Cloudbase Access, SKO Martell, SKO Pro, SKO Plus, SMO 10P, Simple Key One, RFID, NFC, reconocimiento facial, citofonía inteligente"
        path="/sko"
        breadcrumbs={[
          { name: 'Inicio', item: '/' },
          { name: 'Productos', item: '/#modulos' },
          { name: 'Controladoras SKO', item: '/sko' }
        ]}
        extraSchemas={[skoLineSchema]}
      />
      <div className="min-h-screen bg-white" data-testid="sko-page">
        <Header />

        {/* HERO */}
        <section className="relative pt-32 pb-24 bg-[#0b1a3a] overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-blue-600/20 blur-3xl"></div>
            <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-indigo-500/20 blur-3xl"></div>
          </div>

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="max-w-5xl mx-auto text-center">
              <div className="inline-flex items-center gap-3 mb-8 px-5 py-2 bg-white/10 border border-white/20 rounded-full backdrop-blur">
                <img
                  src="https://customer-assets.emergentagent.com/job_smart-workspaces/artifacts/joupqq6v_logo_blue_horizontal.png"
                  alt="Cloudbase"
                  className="h-6 brightness-0 invert"
                />
                <span className="text-white font-semibold tracking-widest text-xs">ACCESS</span>
              </div>

              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                Control de acceso <span className="text-blue-400">inteligente</span>
              </h1>
              <p className="text-xl sm:text-2xl text-blue-100/80 mb-12 font-light max-w-3xl mx-auto">
                Una solución para cada espacio. Hardware diseñado para integrarse con tu operación en la nube.
              </p>

              <div className="flex flex-wrap justify-center items-center gap-8 mb-12 text-sm font-semibold tracking-widest">
                <span className="text-blue-300">PERSONAS</span>
                <span className="text-white/30">·</span>
                <span className="text-blue-300">ESPACIOS</span>
                <span className="text-white/30">·</span>
                <span className="text-blue-300">POSIBILIDADES</span>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  size="lg"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-7 text-base rounded font-semibold"
                  onClick={() => setModalOpen(true)}
                  data-testid="sko-hero-cta"
                >
                  Solicitar Demo
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="border-2 border-white/40 text-white hover:bg-white hover:text-[#0b1a3a] px-10 py-7 text-base rounded font-semibold"
                  onClick={() => {
                    document.getElementById('productos-sko')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  data-testid="sko-hero-explore"
                >
                  Explorar modelos
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* PRODUCT GRID */}
        <section id="productos-sko" className="py-24 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <p className="text-sm font-semibold text-blue-600 tracking-widest mb-3">LA FAMILIA SKO</p>
              <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-4">
                Cinco controladoras, un ecosistema
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light">
                Elige el modelo según el tipo de espacio. Todas se gestionan desde la misma consola Cloudbase.
              </p>
            </div>

            <div className="grid lg:grid-cols-2 gap-8 max-w-7xl mx-auto">
              {products.map((p, i) => {
                const accent = accentClasses[p.accent];
                const isLast = i === products.length - 1;
                return (
                  <article
                    key={p.id}
                    className={`relative bg-[#0b1a3a] rounded-2xl overflow-hidden border border-white/10 shadow-2xl ${
                      isLast ? 'lg:col-span-2' : ''
                    }`}
                    data-testid={`sko-product-${p.id}`}
                  >
                    <div className={`grid ${isLast ? 'lg:grid-cols-[1fr_1fr]' : 'md:grid-cols-[260px_1fr]'} gap-0`}>
                      {/* Image */}
                      <div className="relative bg-gradient-to-br from-white/5 to-transparent flex items-center justify-center p-8">
                        <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-[11px] font-bold tracking-widest ${accent.chip}`}>
                          {p.scenarioLabel}
                        </div>
                        <img
                          src={p.image}
                          alt={p.name}
                          className="w-full max-w-[220px] object-contain drop-shadow-2xl"
                          loading="lazy"
                        />
                      </div>

                      {/* Content */}
                      <div className="p-8 lg:p-10 flex flex-col">
                        <h3 className="text-3xl font-bold text-white mb-2">{p.name}</h3>
                        <p className={`${accent.text} font-medium mb-6`}>{p.tagline}</p>

                        <div className="space-y-2.5 mb-6">
                          {p.features.map((f, j) => {
                            const Icon = FEATURE_ICONS[f] || Check;
                            return (
                              <div key={j} className="flex items-center gap-3 text-sm text-blue-50/90">
                                <div className={`w-8 h-8 rounded-md flex items-center justify-center ${accent.bg}`}>
                                  <Icon className={`w-4 h-4 ${accent.text}`} />
                                </div>
                                <span>{f}</span>
                              </div>
                            );
                          })}
                        </div>

                        <div className={`rounded-lg p-4 ${accent.bg} border ${accent.border}`}>
                          <p className="text-xs font-semibold text-white/80 uppercase tracking-wider mb-2">
                            Usos recomendados
                          </p>
                          <div className="flex flex-wrap gap-2">
                            {p.uses.map((u, k) => (
                              <span
                                key={k}
                                className="text-xs text-blue-50/90 bg-white/5 px-2.5 py-1 rounded"
                              >
                                {u}
                              </span>
                            ))}
                          </div>
                        </div>

                        <p className="mt-6 text-xs text-blue-200/60 font-medium tracking-widest">
                          {p.scenario.toUpperCase()}
                        </p>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        {/* PILLARS */}
        <section className="py-24 bg-white border-t border-gray-100">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
                Una plataforma, múltiples posibilidades
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Toda la línea SKO corre sobre Cloudbase Access, nuestro software en la nube.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
              {pillars.map((p, i) => {
                const Icon = p.icon;
                return (
                  <div
                    key={i}
                    className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 p-8 rounded-xl hover:shadow-lg transition-shadow"
                    data-testid={`sko-pillar-${i}`}
                  >
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-5">
                      <Icon className="w-6 h-6 text-blue-600" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{p.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{p.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* BRAND CUSTOMIZATION (video) */}
        <section className="py-24 bg-[#0b1a3a] relative overflow-hidden" data-testid="sko-branding-section">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-10 -left-20 w-96 h-96 rounded-full bg-blue-500/20 blur-3xl"></div>
            <div className="absolute bottom-10 -right-20 w-96 h-96 rounded-full bg-indigo-500/20 blur-3xl"></div>
          </div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-sm font-semibold text-blue-400 tracking-widest mb-3">
                  WHITE LABEL · MARCA BLANCA
                </p>
                <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight">
                  Tu marca, en cada <span className="text-blue-400">pantalla</span> y cada app
                </h2>
                <p className="text-lg text-blue-100/80 mb-8 leading-relaxed font-light">
                  Personalizamos todos los dispositivos y aplicaciones Cloudbase con tu identidad visual: logos, paletas de color, tipografía y mensajes. Para que tus clientes vean una experiencia 100% tuya, no una genérica.
                </p>
                <ul className="space-y-3 mb-8">
                  {[
                    'Logo y colores en pantallas de acceso y MeetingRoom',
                    'App móvil con tu marca y nombre en App Store / Play Store',
                    'Fondos y mensajes dinámicos según horario o espacio',
                    'Portal web del cliente con tu dominio y look & feel'
                  ].map((f, i) => (
                    <li key={i} className="flex items-start gap-3 text-blue-50/90">
                      <Check className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 rounded font-semibold inline-flex items-center gap-2"
                  onClick={() => setModalOpen(true)}
                  data-testid="sko-branding-cta"
                >
                  Personalizar para mi marca
                  <ArrowRight className="w-5 h-5" />
                </Button>
              </div>

              <div className="relative">
                <div className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-black">
                  <video
                    src={PRODUCT_IMAGES.brandingVideo}
                    poster={PRODUCT_IMAGES.smo10p}
                    className="w-full h-auto block"
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    data-testid="sko-branding-video"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 bg-blue-600 text-white text-xs font-bold tracking-widest px-4 py-2 rounded-full shadow-lg">
                  CUSTOM BRANDING
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* VERTICALS CROSS-LINK */}
        <section className="py-24 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center">
              <div>
                <p className="text-sm font-semibold text-blue-600 tracking-widest mb-3">
                  SOFTWARE INTEGRADO
                </p>
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Cada controladora corre con el módulo <span className="text-blue-600">Control de Acceso</span>
                </h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Permisos, usuarios, horarios, visitas, auditoría e integraciones con video vigilancia y Azure AD. Toda la operación desde la consola Cloudbase.
                </p>
                <div className="flex flex-wrap gap-4">
                  <Button
                    className="bg-gray-900 hover:bg-black text-white px-8 py-6 rounded font-semibold"
                    onClick={() => (window.location.href = '/control-acceso')}
                    data-testid="sko-link-software"
                  >
                    Ver software de Control de Acceso
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </div>
              </div>
              <div className="relative">
                <img
                  src={PRODUCT_IMAGES.infographic}
                  alt="Cloudbase Access - Resumen de la línea SKO"
                  className="w-full rounded-xl shadow-2xl border border-gray-200"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        {/* AUDIENCES */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
                Pensado para cada tipo de espacio
              </h2>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
              {[
                { icon: Users, title: 'Coworks', desc: 'Membresías, acceso 24/7 y reservas sincronizadas.' },
                { icon: Building, title: 'Edificios y Condominios', desc: 'Residentes, visitas, delivery y citofonía digital.' },
                { icon: Shield, title: 'Inmobiliarias', desc: 'Multi-propiedad y gestión perimetral centralizada.' },
                { icon: Zap, title: 'Conserjerías', desc: 'Comunicación directa con residentes vía APP.' }
              ].map((v, i) => {
                const Icon = v.icon;
                return (
                  <div
                    key={i}
                    className="bg-[#0b1a3a] text-white p-8 rounded-xl border border-blue-900/50"
                    data-testid={`sko-audience-${i}`}
                  >
                    <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center mb-5">
                      <Icon className="w-6 h-6 text-blue-300" />
                    </div>
                    <h3 className="text-xl font-bold mb-2">{v.title}</h3>
                    <p className="text-blue-200/70 text-sm leading-relaxed">{v.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="py-24 bg-[#0b1a3a] relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-10 left-1/4 w-80 h-80 rounded-full bg-blue-500/20 blur-3xl"></div>
            <div className="absolute bottom-10 right-1/4 w-80 h-80 rounded-full bg-indigo-500/20 blur-3xl"></div>
          </div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                ¿Qué controladora SKO necesita tu edificio?
              </h2>
              <p className="text-xl text-blue-100/80 mb-10 font-light">
                Agenda una demo y te asesoramos según el tipo de acceso, la cantidad de usuarios y la integración con tu operación actual.
              </p>
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-7 text-base rounded font-semibold inline-flex items-center gap-2"
                onClick={() => setModalOpen(true)}
                data-testid="sko-footer-cta"
              >
                Solicitar Demo
                <ArrowRight className="w-5 h-5" />
              </Button>
            </div>
          </div>
        </section>

        <Footer />

        <LeadModal
          open={modalOpen}
          onOpenChange={setModalOpen}
          sourceDetail="Landing SKO - Cloudbase Access"
        />
      </div>
    </>
  );
}
